import apiClient from 'api';
import { fetchAllFromMonitorServer } from 'api/common';
import { filterForAllowedProperties } from 'utils/format';

const monitorApiBaseUrl = window.env.REACT_APP_MONITOR_API_PATH;
const northgateApiBaseUrl = window.env.REACT_APP_NORTHGATE_API_PATH;
export const EDIT_PROPERTIES = [
  'aggregatorId',
  'deviceId',
  'indeNodeIdList',
  'registrationPin',
  'topoNodeIdList',
  'pollRate',
  'edevPostRate',
  'mupPostRate',
  'protocol',
  'deviceId',
  'localDevice'
];

export const allowedDevicesProperties = [
  'lfdi',
  'deviceId',
  'registrationPin',
  'protocol',
  'sfdi',
  'aggregatorId',
  'indeNodeIdList',
  'topoNodeIdList',
  'localDevice'
];

export const allowedConfigurationProperties = [
  'edevListPollRate',
  'mupListPollRate'
];

export const fetchAllDevices = async (queryParams = {}) => {
  const devices = await fetchAllFromMonitorServer(
    'device',
    ['id', 'aggregatorId', 'sfdi', 'start', 'limit'],
    queryParams
  );
  return devices.map(device =>
    filterForAllowedProperties(device, allowedDevicesProperties)
  );
};

export const fetchDevicesById = async deviceIds => {
  return await Promise.all(
    deviceIds.map(async id => {
      return await apiClient.get(monitorApiBaseUrl, `/device/${id}`);
    })
  );
};

export const fetchDeviceById = async deviceId => {
  return await apiClient.get(monitorApiBaseUrl, `/device/${deviceId}`);
};

export const fetchDeviceBySFDI = async sfdi => {
  const { devices = [] } = await fetchAllDevices({ sfdi });
  return devices[0] || {};
};

export const fetchDeviceAlarms = async (queryParams = {}) => {
  return await fetchAllFromMonitorServer(
    'alarm',
    ['devId', 'status', 'start', 'limit'],
    queryParams
  );
};

export const edit = async (device, deviceId) => {
  return await apiClient.put(
    northgateApiBaseUrl,
    `/device/${deviceId}`,
    device
  );
};

export const remove = async deviceId => {
  return await apiClient.delete(northgateApiBaseUrl, `/device/${deviceId}`);
};

export const create = async device => {
  return await apiClient.post(northgateApiBaseUrl, `/device`, device);
};

export const getMeterDataLogFiles = async deviceId => {
  return await apiClient.get(monitorApiBaseUrl, `/meterdatalog/${deviceId}`);
};

export const downloadDeviceMeterData = async (deviceId, current, fileName) => {
  const meterPath = current ? `current` : `prev/${fileName}`;
  const meterData = await apiClient.get(
    monitorApiBaseUrl,
    `/meterdatalog/${deviceId}/${meterPath}`
  );
  return meterData;
};

export const getConfigOptions = async () => {
  return await apiClient.get(monitorApiBaseUrl, `/config`);
};

export const setConfigOptions = async configOptions => {
  return await apiClient.put(northgateApiBaseUrl, `/config`, configOptions);
};
